import { createSelector } from '@reduxjs/toolkit'
import { type RootState } from 'redux/store'

const projectIdSelector = (state: RootState) => state.settings.projectId
export const projectsSelector = (state: RootState) => state.settings.projects

export const currentProjectSelector = createSelector(
  [projectIdSelector, projectsSelector],
  (projectId, projects) => {
    return projects.find(it => it?.id === projectId)
  }
)
